import { render, staticRenderFns } from "./AllProducts.vue?vue&type=template&id=4d21378c&scoped=true"
import script from "./AllProducts.vue?vue&type=script&lang=js"
export * from "./AllProducts.vue?vue&type=script&lang=js"
import style0 from "./AllProducts.vue?vue&type=style&index=0&id=4d21378c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d21378c",
  null
  
)

export default component.exports